export const firebase = {
    apiKey: "AIzaSyAdU0mXqLe0FXKPS9px3ZUxcy6TNJ4JMag",
    authDomain: "javascriptmeetup-10f9a.firebaseapp.com",
    databaseURL: "https://javascriptmeetup-10f9a.firebaseio.com",
    projectId: "javascriptmeetup-10f9a",
    storageBucket: "javascriptmeetup-10f9a.appspot.com",
    messagingSenderId: "958215690031"
};



// WEBPACK FOOTER //
// D:/AppDev/meetup/kla-firebase-poker/shared/configs/firebase.ts